
export const visionTranslations = {
  visionMissionValues: {
    fr: "Notre Vision, Mission et Valeurs",
    en: "Our Vision, Mission and Values"
  },
  visionText: {
    fr: "Construire le réseau humain le plus actif et fiable dans l'univers tech et entrepreneurial à travers le monde. Un lieu d'opportunités, d'aventures et de transformation où l'on ne vient pas pour se montrer, mais pour faire.",
    en: "Building the most active and reliable human network in the tech and entrepreneurial universe around the world. A place of opportunities, adventures and transformation where one does not come to show off, but to do."
  },
  missionText: {
    fr: "Rassembler une élite active d'entrepreneurs et d'experts engagés dans la transformation du monde par l'innovation, l'entraide et l'action concrète.",
    en: "Gathering an active elite of entrepreneurs and experts committed to transforming the world through innovation, mutual aid and concrete action."
  },
  values: {
    fr: "Valeurs",
    en: "Values"
  },
  humanExcellence: {
    fr: "Exigence humaine",
    en: "Human Excellence"
  },
  sharedTrust: {
    fr: "Confiance partagée",
    en: "Shared Trust"
  },
  generosityOfAction: {
    fr: "Générosité d'action",
    en: "Generosity of Action"
  },
  livelyCuriosity: {
    fr: "Curiosité vive",
    en: "Lively Curiosity"
  },
  worldOpeness: {
    fr: "Ouverture sur le monde",
    en: "Openness to the World"
  },
};
